// ABOUTME: Shared keyboard activation helper for elements that act as buttons.
// ABOUTME: Returns a React onKeyDown handler firing the action on Enter and Space.
import { KeyboardEvent, KeyboardEventHandler } from 'react';

export const onActivationKey =
  <T extends Element>(
    handler: (event: KeyboardEvent<T>) => void
  ): KeyboardEventHandler<T> =>
  (event: KeyboardEvent<T>) => {
    if (event.target !== event.currentTarget) {
      return;
    }
    if (event.key === 'Enter' || event.key === ' ' || event.key === 'Spacebar') {
      if (event.key !== 'Enter') {
        event.preventDefault();
      }
      handler(event);
    }
  };
